

import { BaseSystemComponent } from './system';

export default class System extends BaseSystemComponent { }
